import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imPagination', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/pagination/pagination.html'),
        controller: 'ImPaginationController',
        controllerAs: 'ImPaginationCtrl',
        bindings: {
            apiFunction: '<',
            apiString: '<',
            clientId: '<?',
            params: '<',
            selectedObject: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/pagination/pagination.component.ts